import styled, {css} from 'styled-components'

export const StyledAccessesValidatorsEmptyStateWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: ${spacing * 14}px 0;
        gap: ${spacing}px;
    `
)
